export default {
  /**
   * @description 创建url传参
   * @example {a:1,b:2} => 'a=1&b=2'
   * @param {Object} obj
   * @returns {Array}
   */
  url_param_create: obj => {
    if (!obj) return ''
    let arr = Object.keys(obj).map(key => {
      if (obj[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key])
    })
    return arr.filter(x => x).join('&')
  },

  /**
   * @description 获取url参数对象
   * @example 'a=1&b=2' => {a:1,b:2}
   * @param {string} url
   * @returns {Object}
   */
  url_param_query: url => {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
      const name = decodeURIComponent($1)
      let val = decodeURIComponent($2)
      val = String(val)
      obj[name] = val
      return rs
    })
    return obj
  },
  // url_param_query: url => {
  //   const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  //   if (!search) {
  //     return {}
  //   }
  //   const obj = {}
  //   const searchArr = search.split('&')
  //   searchArr.forEach(v => {
  //     const index = v.indexOf('=')
  //     if (index !== -1) {
  //       const name = v.substring(0, index)
  //       const val = v.substring(index + 1, v.length)
  //       obj[name] = val
  //     }
  //   })
  //   return obj
  // },
}
